// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1r-2";
export var blackBorderOnHover = "_1r-7";
export var cell = "_1r-6";
export var cellContainer = "_1r-3";
export var checked = "_1r-8";
export var disabled = "_1r-5";
export var featuredIconCellContainer = "_1r-9";
export var featuredIconTextContainer = "_1r-b";
export var featuredIconWrapper = "_1r-a";
export var noBorder = "_1r-c";
export var orangeSelectedRow = "_4j-3";
export var overflowableText = "_1r-0";
export var overflowableTextContainer = "_1r-1";
export var row = "_1u-0";
export var rowCheckboxCell = "_1r-4";
export var selectableTable = "_4j-2";